import { chain, toNumber, isUndefined, get, includes } from 'lodash';

export const getTypeModalState = (variantsType, codeResponse, state, omitCode = 500) => {
  const filterVariantType = chain(variantsType)
    .omit(omitCode)
    .map((value, key) => toNumber(key))
    .value();

  if (isUndefined(codeResponse)) return get(state, ['modal', 'type']);
  
  if (includes(filterVariantType, codeResponse)) return codeResponse

  return omitCode;
}